import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { Draw, Modify, Snap } from 'ol/interaction';
import { createBox, createRegularPolygon } from 'ol/interaction/Draw';

const source = new VectorSource();
const vectorDraw = new VectorLayer({
  title: 'Çizim Katmanı',
  source: source,
});

const defaultStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: '#0099FF',
    width: 3,
  }),
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({
      color: '#0099FF',
    }),
  }),
});

const editStyle = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new Stroke({
    color: '#ffcc33',
    width: 3,
  }),
  image: new CircleStyle({
    radius: 7,
    fill: new Fill({
      color: '#ffcc33',
    }),
  }),
});

let draw, snap;
const modify = new Modify({ source: source });
snap = new Snap({ source: source });

// type 'Point','LineString','Polygon','Circle','Square','Box',,,'LineString','LineString';freehand: true

export const startDrawService = (map, type, free) => {
  return new Promise((resolve, reject) => {
    vectorDraw.setStyle(defaultStyle);
    
    // Önceki draw interaction'larını temizle
    map.removeInteraction(draw);
    map.removeInteraction(modify);
    map.removeInteraction(snap);
    
    // Çizim katmanının haritada olup olmadığını kontrol et, yoksa ekle
    const isLayerOnMap = map.getLayers().getArray().some(layer => 
      layer === vectorDraw
    );
    if (!isLayerOnMap) {
      map.addLayer(vectorDraw);
    }

    let geometryFunction;
    if (type === 'Square') {
      type = 'Circle';
      geometryFunction = createRegularPolygon(4);
      draw = new Draw({
        source: source,
        type: type,
        freehand: free,
        geometryFunction: geometryFunction,
      });
      map.addInteraction(draw);
      map.addInteraction(snap);
    } else if (type === 'Box') {
      type = 'Circle';
      geometryFunction = createBox();
      draw = new Draw({
        source: source,
        type: type,
        freehand: free,
        geometryFunction: geometryFunction,
      });
      map.addInteraction(draw);
      map.addInteraction(snap);
    } else {
      draw = new Draw({
        source: source,
        type: type,
        freehand: free,
        geometryFunction: geometryFunction,
      });
      map.addInteraction(draw);
      map.addInteraction(snap);
    }
    resolve(vectorDraw);
  });
};

export const stopDrawService = (map) => {
  map.removeInteraction(draw);
  map.removeInteraction(snap);
};

export const cleanDrawService = (map) => {
  let features = vectorDraw.getSource().getFeatures();
  features.forEach((feature) => {
    vectorDraw.getSource().removeFeature(feature);
  });
  map.removeLayer(vectorDraw);
  map.removeInteraction(draw);
  map.removeInteraction(modify);
  map.removeInteraction(snap);
};

export const modifyDrawService = (map) => {
  map.addInteraction(modify);
  vectorDraw.setStyle(editStyle);
};

export const cleanModifyService = (map) => {
  map.removeInteraction(modify);
  vectorDraw.setStyle(defaultStyle);
};
